import { render, staticRenderFns } from "./StorageSelect.vue?vue&type=template&id=188236d0&scoped=true&"
import script from "./StorageSelect.vue?vue&type=script&lang=js&"
export * from "./StorageSelect.vue?vue&type=script&lang=js&"
import style0 from "./StorageSelect.vue?vue&type=style&index=0&id=188236d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188236d0",
  null
  
)

export default component.exports